'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const CommandButtonDirective=require('../../../../dist-es6/client/directives/commandButtonDirective/commandButtonDirective');let

CommandCheckboxDirective=function(_CommandButtonDirecti){_inherits(CommandCheckboxDirective,_CommandButtonDirecti);function CommandCheckboxDirective(){_classCallCheck(this,CommandCheckboxDirective);return _possibleConstructorReturn(this,_CommandButtonDirecti.apply(this,arguments))}CommandCheckboxDirective.prototype.
















factory=function factory(){
let directive=_CommandButtonDirecti.prototype.factory.call(this);
directive.transclude=!0;
return directive;
};_createClass(CommandCheckboxDirective,[{key:'objectBindings',get:function(){return['onChangeCommand','isChecked','self']}},{key:'textBindings',get:function(){return['inProgressText','completionText']}},{key:'templateUrl',get:function(){return'/templates/directives/commandCheckboxDirective/commandCheckboxTemplate'}},{key:'controller',get:function(){return CommandCheckboxDirectiveController}}]);return CommandCheckboxDirective}(CommandButtonDirective);let


CommandCheckboxDirectiveController=function(){_createClass(CommandCheckboxDirectiveController,null,[{key:'$inject',get:function()
{
return[];
}}]);

function CommandCheckboxDirectiveController(){_classCallCheck(this,CommandCheckboxDirectiveController);
this._id=Guid.create().toString();
}CommandCheckboxDirectiveController.prototype.

onCheckBoxChanged=function(){var ref=_asyncToGenerator(function*(){
yield this.onChangeCommand.execute(this.isChecked);
});function onCheckBoxChanged(){return ref.apply(this,arguments)}return onCheckBoxChanged}();_createClass(CommandCheckboxDirectiveController,[{key:'id',get:function()

{
return this._id;
}}]);return CommandCheckboxDirectiveController}();



module.exports=CommandCheckboxDirective;
//# sourceMappingURL=commandCheckboxDirective.js.map
